import Foundation from "@microsoft/fast-components-foundation-react";
import { ContextMenuItem as BaseContextMenuItem } from "@microsoft/fast-components-react-base";
import { classNames } from "@microsoft/fast-web-utilities";
import React from "react";
import { DisplayNamePrefix } from "../utilities";
class ContextMenuItem extends Foundation {
    constructor() {
        super(...arguments);
        this.handledProps = {
            after: void 0,
            before: void 0,
        };
    }
    render() {
        return (React.createElement(BaseContextMenuItem, Object.assign({}, this.unhandledProps()),
            this.props.before !== undefined ? this.props.before : undefined,
            React.createElement("span", { className: classNames(this.props.managedClasses.contextMenuItem_contentRegion) }, this.props.children),
            this.props.after !== undefined ? this.props.after : undefined));
    }
}
ContextMenuItem.displayName = `${DisplayNamePrefix}ContextMenuItem`;
ContextMenuItem.defaultProps = {
    managedClasses: {},
};
export default ContextMenuItem;
